import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var ft = /*#__PURE__*/function () {
  function ft(t, s, l, n, i) {
    _classCallCheck(this, ft);

    this.triggerId = t, this.fi = s, this.pi = l, this.di = n, this.vi = i;
  }

  _createClass(ft, null, [{
    key: "fromJson",
    value: function fromJson(t, s, l, n, i) {
      return null == t || null == t.trigger_id ? null : new ft(t.trigger_id, s, l, n, i);
    }
  }]);

  return ft;
}();

export { ft as default };